import { EMAIL_PATTERN } from './constants';

export const validateEmail = (value: string): string | boolean => {
  return !value || EMAIL_PATTERN.test(value) || 'Email is not valid';
};
